import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  Divider,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import Terms from './TermsGDC';
import { acceptTerms } from '../../http/api/user';
import toast from 'react-hot-toast';

type Props = {
  termsChecked: boolean;
};

export default function DataTreatmentModal({ termsChecked }: Props) {
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  const acceptTermsMutation = useMutation({
    mutationFn: acceptTerms,
  });

  useEffect(() => {
    if (!termsChecked) {
      setOpen(true);
    }
  }, [termsChecked]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await acceptTermsMutation.mutateAsync({
        termsChecked: checked,
      });

      if (response) {
        toast.success('Términos y condiciones aceptados con éxito.');
        setOpen(false);
      }

      return;
    } catch (_e) {
      toast.error(
        'Error al aceptar los términos y condiciones. Por favor, inténtelo de nuevo.'
      );
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth="md" disableEscapeKeyDown>
      <DialogTitle>Tratamiento de datos personales</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers sx={styles.content}>
          <Terms />
          <br />

          <Divider />
          <br />

          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
            }
            label={
              'He leído y acepto el tratamiento de mis datos personales y los términos asociados.'
            }
          />
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={!checked || acceptTermsMutation.isPending}
          >
            Aceptar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

const styles = {
  content: {
    padding: '32px',
  },
};
